import React from 'react'

import { colors } from '../../constants/theme'

const socialMail = ({ background = colors.black }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.4 0H1.6C0.72 0 0 0.72 0 1.6V14.4C0 15.28 0.72 16 1.6 16H14.4C15.28 16 16 15.28 16 14.4V1.6C16 0.72 15.28 0 14.4 0ZM4.8 13.6H2.4V6.4H4.8V13.6ZM3.6 5.04C2.8 5.04 2.16 4.4 2.16 3.6C2.16 2.8 2.8 2.16 3.6 2.16C4.4 2.16 5.04 2.8 5.04 3.6C5.04 4.4 4.4 5.04 3.6 5.04ZM13.6 13.6H11.2V9.36C11.2 8.72003 10.64 8.16 10 8.16C9.36 8.16 8.8 8.72003 8.8 9.36V13.6H6.4V6.4H8.8V7.36C9.2 6.72 10.08 6.24 10.8 6.24C12.32 6.24 13.6 7.52 13.6 9.04V13.6Z"
      fill={background}
    />
  </svg>
)

export default socialMail
